<template>
  <v-btn icon @click="playTune">
    <v-icon v-show="!$store.getters.musicPlayerModuleGetIsPlaying">play_arrow</v-icon>
    <v-icon v-show="$store.getters.musicPlayerModuleGetIsPlaying">pause</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: `PlayPauseBtn`,
  computed: {
    playStatus () {
      return this.$store.getters.musicPlayerModuleGetIsPlaying
    }
  },
  methods: {
    playTune () {
      let audio = document.querySelector('#audio')
      if (!this.playStatus) {
        setTimeout(audio.play(), 10)
        this.$store.commit('musicPlayerModuleUpdateIsPlaying', true)
      } else if (this.playStatus) {
        setTimeout(audio.pause(), 10)
        this.$store.commit('musicPlayerModuleUpdateIsPlaying', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PlayPauseBtn.vue